import React from 'react';
import logo from '../logolumi.png';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src={logo} alt="LumiMind" className="footer__logo-img" />
              <span>LumiMind</span>
            </div>
            <p>
              Kurator, beteendevetare och författare. Socialt arbete,
              ungdomsarbete och stöd till skolor och organisationer.
            </p>
          </div>
          <div className="footer__nav">
            <h4>Sidor</h4>
            <a href="#hero">Hem</a>
            <a href="#services">Tjänster</a>
            <a href="#about">Om mig</a>
            <a href="#contact">Kontakt</a>
          </div>
          <div className="footer__nav">
            <h4>Tjänster</h4>
            <a href="#services">Stöd till skolor</a>
            <a href="#services">Ungdomsarbete</a>
            <a href="#services">Föreläsningar</a>
          </div>
          <div className="footer__nav">
            <h4>Kontakt</h4>
            <a href="mailto:hafize.basak@hotmail.com">hafize.basak@hotmail.com</a>
          </div>
        </div>
        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Hafize Cetin Konsult. Alla rättigheter förbehållna.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
